import { Component, ElementRef, EventEmitter, Input, Output, ViewChild } from '@angular/core';
import { CommonService } from 'src/@services/common.service';
import {
  PremiumContent,
  RetailProgramInvestment,
} from 'src/models/retailProgramInvestment.model';
import { responseMessageStatus, ResponseStatus, RetailProgramInvestmentStatus } from '../../enum';
import { InnerPagesService } from 'src/app/pages/common-layout/inner-pages.service';
import { FormGroup } from '@angular/forms';
import { FormService } from 'src/@services/form.service';
import { ActivatedRoute } from '@angular/router';
import { CommonPagesService } from '../../common-pages.service';
import { Investor } from 'src/models/investment.model';
import { DatePipe } from '@angular/common';

@Component({
    selector: 'app-renew-premium',
    templateUrl: './renew-premium.component.html',
    styleUrls: ['./renew-premium.component.scss'],
    standalone: false
})
export class RenewPremiumComponent {
  // @Input() isRenewPremiumScreenVisible: boolean;
  @Input() premiumContent: any;
  @Input() renewalDiscountPercentage: number;
  @Input() programDetail: any = '';
  @Input() currentSelectedData: any;
  @Output() closeModal = new EventEmitter<any>();
  sortField: string = 'RenewalDate';
  sortOrder: string = 'asc';
  isDataLoading: boolean = true;
  consolidateRenewalDate: any;
  currentInvestorData: any;
  isVisibleInfoModal: boolean = false;

  page: number = 0;
  progressBar: number = 0;
  listOfCurrentPageData: any[] = [];
  setOfCheckedId = new Set<number>();
  selectedBrandKeyList: string[] = [];
  checked = false;
  indeterminate = false;
  loadingListData: boolean = true;
  expandSet: Set<any> = new Set();
  reviewData: any;
  currentNextMonthYear: string = '';
  netTerms: number = 30;
  supplierId: string;
  // reviewBrandsPageData: any
  companyDetails: {
    name: '';
    address1: '';
    address2: '';
    city: '';
    state: '';
    zip: '';
    country: '';
    qboSupplierId: '';
    retailPrograms: {
      _id: '';
      name: '';
      code: '';
      isActive: '';
      retailSupplierId: '';
    }[];
  };
  formattedAddress: string = '';
  form: FormGroup;
  programId: string;
  operatorSiteId: string;
  listOfReps: any[] = [];
  isLoading = false;
  showInvestorModal = false;
  amountToPay: number;
  isSupplierRequest: boolean = true;
  investmentLoading = false;
  isDifferentRenewalMonthsForBrands: boolean = false;
  invoiceDescription: string =
    'Renewal - Full year of Premium Content marketing services for the following brands: ';
  @ViewChild('proratedDiscountHeader', { read: ElementRef })
  proratedDiscountHeader!: ElementRef;
  discountHeaderLeft = 0;
  now = new Date();
  disableBrandsSelections: number = 0;
  earliestRenewalDate: any;
  estArrivalDate: Date = new Date();

  supplierDetails = JSON.parse(sessionStorage.getItem('SupplierDetails'));

  userDetails = JSON.parse(localStorage.getItem('UserInfo'));
  constructor(
    private _cS: CommonService,
    private _iS: InnerPagesService,
    public _fS: FormService,
    private route: ActivatedRoute,
    private _cpS: CommonPagesService,
    private datepipe: DatePipe
  ) {
    this.supplierId = this.route.snapshot.paramMap.get('supplierId');
    _fS.retailProgramInvestmentForm_fb();
  }

  ngOnInit() {
    this.programId = this.route.snapshot.queryParamMap.get('programId');
    this.page = 0;
    this.getAllPurchasedBrands();
    if (this.programDetail.invoiceDescriptionText) {
      this.invoiceDescription = 'Renewal - ' + this.programDetail.invoiceDescriptionText + ' '
    }

    this.getSupplierDetails();
  }

  get tableData() {
    switch (this.progressBar) {
      case 1: return this.isDifferentRenewalMonthsForBrands ? this.consolidationScreenData : this.reviewData;
      case 2: return this.reviewData;
      default: return [];
    }
  }

  getAllPurchasedBrands() {
    this.loadingListData = true
    this._iS
      .getPremiumContent(
        [],
        this.programId,
        [],
        [],
        '',
        this.sortField,
        this.sortOrder,
        1,
        -1,
        false
      )
      .subscribe((contentRes: any) => {
        this.isDataLoading = false;
        if (contentRes.responseStatus === ResponseStatus.success) {
          this.premiumContent = contentRes.result?.records || [];

          // if(this.premiumContent?.length > 1){
          //   this.isVisibleInfoModal = true
          // }

          this.loadingListData = false;
          this.renewalDiscountPercentage = contentRes.renewalDiscountPercentage;
          if (this.premiumContent?.length > 0) {
            if (!this.currentSelectedData) {

              //filter premium content with brandInvestmentDetail.retailProgramInvestmentStatus are 2 or 3 or 4
              this.premiumContent = this.premiumContent.filter((item: any) =>
                [2, 3, 4].includes(item.brandInvestmentDetail.retailProgramInvestmentStatus)
              );
            }
            this.listOfCurrentPageData = this.premiumContent;
            if (this.listOfCurrentPageData.length > 0) {
              this.onExpandChange(this.listOfCurrentPageData[0].id, true);
            }
          }
          if (this.currentSelectedData) {


            const selectedBrands = this.premiumContent.filter((item: any) => item.brandInvestmentDetail.retailProgramInvestmentId === this.currentSelectedData.brandInvestmentDetail.retailProgramInvestmentId);
            this.premiumContent = this.premiumContent.filter((item: any) => item.brandInvestmentDetail.retailProgramInvestmentStatus === RetailProgramInvestmentStatus.Pending || item.brandInvestmentDetail.retailProgramInvestmentStatus === RetailProgramInvestmentStatus.Active);

            //update premium content renewal date with renewal date - 1 year
            this.premiumContent = this.premiumContent.map((item: any) => {
              const renewalDate = new Date(item.renewalDate);
              renewalDate.setFullYear(renewalDate.getFullYear() - 1);
              return {
                ...item,
                renewalDate: this.datepipe.transform(renewalDate, 'yyyy-MM-dd'),
              };
            });

            this.listOfCurrentPageData = JSON.parse(JSON.stringify(this.premiumContent))

            //update listOfCurrentPageData renewal date with renewal date - 1 year
            this.listOfCurrentPageData = this.listOfCurrentPageData.map((item: any) => {
              //only if premium content contains this item
              if (this.premiumContent.find((pc: any) => pc.id === item.id)) {
                const renewalDate = !item.brandInvestmentDetail?.previousRenewalDate?.toString().includes('0001') ? new Date(item.brandInvestmentDetail?.previousRenewalDate) : new Date(item.renewalDate);
                // const previousRenewalDate = new Date(renewalDate.getFullYear() - 1, renewalDate.getUTCMonth(), 1);
                return {
                  ...item,
                  renewalDate: this.datepipe.transform(renewalDate, 'yyyy-MM-dd'),
                };
              } else {
                return item;
              }

            });

            const listOfId = selectedBrands.map((item: any) => item.id);
            listOfId.forEach((id) => {
              this.setOfCheckedId.add(id);
            });

            // this.checked = true;
            //based on length indeterminate or checked property true
            if (this.setOfCheckedId.size === this.premiumContent.length) {
              this.checked = true;
            } else {
              this.indeterminate = true;
            }

            //patch rep in form
            this._fS.retailProgramInvestmentForm.patchValue({
              rep: this.currentSelectedData.brandInvestmentDetail.rep.id,
              isAgreed: true,
            });
          }
        } else {
          this.loadingListData = false;
        }
      });
  }

  //sorting
  sort(key: string, event: string) {
    if (key) {
      this.sortOrder = event == 'descend' ? 'desc' : 'asc';
      this.sortField = event ? key : 'RenewalDate';
      // this.cols.forEach((element) => {
      //   element.sortDir = null;
      // });
      // this.cols[index].sortDir = event;
      // this.page = 1;
      this.getAllPurchasedBrands();
    }
  }
  consolidationScreenData: any[] = [];
  handleOk(nextPageNumber: number) {
    if (nextPageNumber === 1) {
      setTimeout(() => {
        if (this.proratedDiscountHeader) {
          const rect =
            this.proratedDiscountHeader.nativeElement.getBoundingClientRect();
          const wrapperRect = this.proratedDiscountHeader.nativeElement
            .closest('.table-wrapper')
            .getBoundingClientRect();
          this.discountHeaderLeft = rect.left - wrapperRect.left;
        }
      });
      this.reviewData = this.listOfCurrentPageData.filter((content: any) =>
        this.setOfCheckedId.has(content.id)
      );


      const validDates = this.reviewData
        .map((item) => new Date(item.renewalDate))
        .filter((d) => !isNaN(d.getTime()) && d.getFullYear() > 1); // remove invalids like 0001-01-01

      if (validDates.length > 0) {
        this.earliestRenewalDate = validDates.reduce(
          (min, d) => (d < min ? d : min),
          validDates[0]
        );
        //if any of valid date is having more than 11 months difference from earliest date then disable brand selections
        //add flag in review data if renewal date is more than 11 months away from earliest date
        this.reviewData = this.reviewData.map((item) => {
          const renewalDate = new Date(item.renewalDate);
          const diffMonths =
            (renewalDate.getFullYear() -
              this.earliestRenewalDate.getFullYear()) *
            12 +
            (renewalDate.getMonth() - this.earliestRenewalDate.getMonth());

          const newRenewalDate = new Date(renewalDate.getFullYear() + 1,
            renewalDate.getUTCMonth(),
            1);
          return {
            ...item,
            isRenewalDateMoreThan11Months: diffMonths > 11,
            newRenewalDate: this.datepipe.transform(newRenewalDate, 'yyyy-MM-dd'),
          };
        });

        this.consolidateRenewalDate = new Date(
          Date.UTC(
            this.earliestRenewalDate.getUTCFullYear() + 1, // add 1 year
            this.earliestRenewalDate.getUTCMonth(), // keep same month
            1 // force to 1st of that month
          )
        );
      } else {
        this.consolidateRenewalDate = null; // or fallback
      }
      this.currentNextMonthYear = this.getCurrentMonthNextYear();
      this.reviewData = this.calculateProratedData(this.reviewData);



      // if any record from review data has proratedDiscount is different than other records then make isDifferentRenewalMonthsForBrands true
      const discounts = this.reviewData.map((r) => r.proratedDiscount);

      const allSame = discounts.every((val) => val === discounts[0]);

      this.isDifferentRenewalMonthsForBrands = !allSame;
      if (this.isDifferentRenewalMonthsForBrands) {
        this.consolidationScreenData = JSON.parse(JSON.stringify(this.reviewData));
      } else {
        this.consolidationScreenData = [];
      }

      if (this.reviewData?.length > 0) {
        if (!this.isDifferentRenewalMonthsForBrands) {
          //skip 1 step and show next step content
          this.page = nextPageNumber + 1;
          this.progressBar = nextPageNumber;
        } else {
          this.page = nextPageNumber;
          this.progressBar = nextPageNumber;
        }
        //sort reviewData by renewal date ascending
        this.reviewData.sort((a, b) => {
          return new Date(a.renewalDate).getTime() - new Date(b.renewalDate).getTime();
        });

      } else {
        this._cS.displayMessage('warning', 'Please select at least one brand');
      }
      // this.reviewBrandsPageData = []
    } else if (nextPageNumber === 2) {
      this.page = nextPageNumber;
      this.progressBar = nextPageNumber;


      //filter review data is any brand is having isRenewalDateMoreThan11Months true
      this.reviewData = this.reviewData.filter(
        (item) => !item.isRenewalDateMoreThan11Months
      );

      //add property named newRenewalDate in review data based on renewalDate+1 year
      this.reviewData = this.reviewData.map((item) => {
        const renewalDate = new Date(item.renewalDate);
        const newRenewalDate = new Date(
          renewalDate.getFullYear() + 1,
          renewalDate.getMonth() + 1,
          1
        );
        return {
          ...item,
          newRenewalDate: newRenewalDate,
        };
      });

      // if any record from review data has proratedDiscount is different than other records then make isDifferentRenewalMonthsForBrands true
      const discounts = this.reviewData.map((r) => r.proratedDiscount);

      const allSame = discounts.every((val) => val === discounts[0]);

      this.isDifferentRenewalMonthsForBrands = !allSame;
      // this.reviewBrandsPageData = []

      // this.reviewBrandsPageData = JSON.parse(JSON.stringify(this.reviewData));
      //if data has proratedDiscount more than 0 then sort them up and others down
      this.reviewData.sort((a, b) => {
        return b.proratedDiscount - a.proratedDiscount;
      });



    } else if (nextPageNumber === 3) {
      // this.reviewBrandsPageData = []
      this.page = nextPageNumber;
      this.progressBar = nextPageNumber;

      if (this.userDetails.localSupplier) {
        this.getLocalInvestorDetails();
      } else {
        this.getSupplierDetails();
      }
      this.amountToPay = 0;
      this.reviewData.forEach((element) => {
        this.amountToPay += element.proratedPrice;
      });
      let invoiceDescriptionBase =
        'Renewal - Full year of Premium Marketing services';
      if (this.programDetail.invoiceDescriptionText) {
        invoiceDescriptionBase = 'Renewal - ' + this.programDetail.invoiceDescriptionText + ' '
      }
      const brands = this.reviewData.map((e) => { return { name: e.name, amount: e.proratedPrice } });
      const count = brands.length;

      if (count === 1) {
        // Case 1: Only one brand
        this.invoiceDescription = `${invoiceDescriptionBase.trim()} for ${brands[0].name}`;
      } else if (count === 2) {
        // Case 2: Two brands

        if (this.isDifferentRenewalMonthsForBrands) {
          this.invoiceDescription = `${invoiceDescriptionBase.trim()} for ${brands[0].name} ($${brands[0].amount.toFixed(2)}) and ${brands[1].name} ($${brands[1].amount.toFixed(2)})`;
        } else {
          this.invoiceDescription = `${invoiceDescriptionBase.trim()} for ${brands[0].name} and ${brands[1].name} ($500/brand)`;
        }

      } else if (count > 2) {

        if (this.isDifferentRenewalMonthsForBrands) {
          const brandDescriptions = brands
            .map(
              (b, index) =>
                `${b.name} ($${b.amount.toFixed(2)})`
            );

          const allButLast = brandDescriptions.slice(0, -1).join(', ');
          const last = brandDescriptions[brandDescriptions.length - 1];

          this.invoiceDescription = `${invoiceDescriptionBase} for the following brands: ${allButLast}, and ${last}`;
        } else {
          const allButLast = brands.slice(0, -1).map(b => b.name).join(', ');
          const last = brands[brands.length - 1].name;

          this.invoiceDescription = `${invoiceDescriptionBase} for the following brands: ${allButLast}, and ${last} ($500/brand)`;
        }
      }

      this._fS.retailProgramInvestmentForm
        .get('detailedDescription')
        ?.setValue(this.invoiceDescription);
    }
  }
  preventEnter(event: KeyboardEvent) {
    if (event.key === 'Enter') {
      event.preventDefault();
    }
  }
  newCreatedInvestor(event: {
    isVisibleInvestorDrawer: boolean;
    data: Investor;
  }) {
    this.showInvestorModal = event.isVisibleInvestorDrawer;
    if (event.data) {
      this.listOfReps?.splice(0, 0, event.data);
      this.listOfReps[0].id = event.data.id;
      this.showInvestorModal = false;
      this.listOfReps[0].name = event.data.investorDisplayName;
      this._fS.retailProgramInvestmentForm.patchValue({
        rep: this.listOfReps[0].id,
      });
    }
  }

  calculateProratedData(reviewSelectedData: any[]) {
    // Handle null/undefined input
    if (!reviewSelectedData || !Array.isArray(reviewSelectedData)) {
      return [];
    }

    return reviewSelectedData.map((item: any) => {
      // Validate item structure
      if (!item || typeof item !== 'object') {
        return {
          ...item,
          proratedDiscount: 0,
          proratedPrice: 0,
        } as PremiumContent;
      }

      // const brandRenewalDate = this.toDate(item?.renewalDate);

      const brandRenewalDate = new Date(item?.renewalDate);

      const today = new Date();

      // Validate renewal date
      if (!brandRenewalDate) {
        return {
          ...item,
          proratedDiscount: 0,
          proratedPrice: item?.brandAmount ?? 0,
        } as PremiumContent;
      }

      const brandAmount = item?.brandAmount ?? 0;

      // Validate calculations
      if (isNaN(brandAmount) || brandAmount < 0) {
        return {
          ...item,
          proratedDiscount: 0,
          proratedPrice: brandAmount,
        } as PremiumContent;
      }

      let brandPropratedPrice = brandAmount;
      let brandPropratedDiscount = brandAmount;

      // Check if renewal date is in current month or past
      if (
        brandRenewalDate < today ||
        (brandRenewalDate.getMonth() === today.getMonth() &&
          brandRenewalDate.getFullYear() === today.getFullYear())
      ) {
        brandPropratedDiscount = 0;
        brandPropratedPrice = brandAmount;
      } else {
        if (
          brandRenewalDate.getMonth() === this.earliestRenewalDate.getMonth() &&
          brandRenewalDate.getFullYear() ===
          this.earliestRenewalDate.getFullYear()
        ) {
          // Same as earliest → no discount
          brandPropratedDiscount = 0;
          brandPropratedPrice = brandAmount;
        } else {
          const singleMonthAmount = brandAmount / 12;

          // difference in months relative to earliest date
          const monthDiff =
            (brandRenewalDate.getFullYear() -
              this.earliestRenewalDate.getFullYear()) *
            12 +
            (brandRenewalDate.getMonth() - this.earliestRenewalDate.getMonth());

          if (monthDiff > 0 && monthDiff < 12) {
            brandPropratedDiscount = singleMonthAmount * monthDiff;
            brandPropratedPrice = brandAmount - brandPropratedDiscount;
          }

          // Ensure values are not negative
          if (brandPropratedPrice < 0) {
            brandPropratedPrice = 0;
          }
          if (brandPropratedDiscount < 0) {
            brandPropratedDiscount = 0;
          }
        }
      }

      return {
        ...item,
        proratedDiscount: brandPropratedDiscount,
        proratedPrice: brandPropratedPrice,
      } as PremiumContent;
    });
  }

  getInvestorTerms() {
    if (this.currentInvestorData.terms) {
      // this._cpS.getInvestorTerms(option).subscribe((response: any) => {
      //   if (response.responseStatus == ResponseStatus.success) {
      //     this.netTerms = response.result ? response.result : 30;
      //   }
      // });
      if (this.currentInvestorData.terms.id) {
        this.netTerms = this.currentInvestorData.terms.name?.split('Net ')[1]
          ? parseInt(this.currentInvestorData.terms.name?.split('Net ')[1])
          : 30;
      }
    }
  }
  // getInvestorDetails(option: string) {
  //   if (option) {
  //     this._iS.getInvestorDetails(option).subscribe((response: any) => {
  //       if (response.responseStatus == ResponseStatus.success) {
  //         this.currentInvestorData = response.result;
  //       }
  //     });
  //   }
  // }

  getCurrentMonthNextYear(): string {
    const today = new Date();
    const currentMonth = today.getMonth() + 1;
    const nextYear = today.getFullYear() + 1;

    const nextYearDate = new Date(nextYear, currentMonth, 1);

    return nextYearDate.toLocaleDateString('en-US', {
      year: 'numeric',
      month: 'long',
      day: 'numeric',
    });
  }

  handleCancel(data?: any) {
    this.page = 0;
    this.progressBar = 0;
    this.listOfCurrentPageData = [];
    // this.isRenewPremiumScreenVisible = false;
    this.closeModal.emit({ data: data });
  }

  handleGoBack() {
    if (!this.isDifferentRenewalMonthsForBrands) {
      if (this.page < 3) {
        this.page = 0;
        this.progressBar = 0;
      } else {
        this.page = this.page - 1;
        this.progressBar = this.page - 1;
      }
    } else {
      this.page = this.page - 1;
      this.progressBar = this.page;

      // if (this.page === 1) {
      //   this.reviewData = JSON.parse(JSON.stringify(this.consolidationScreenData));
      // }
    }
  }

  // Update the expand change method
  onExpandChange(brandId: any, expand: boolean): void {
    this.expandSet.clear();
    if (expand) {
      this.expandSet.add(brandId);
    } else {
      this.expandSet.delete(brandId);
    }
  }

  // Add brand row selection method
  onBrandRowClick(brandData: any): void {
    this.onItemChecked(brandData.id, !this.setOfCheckedId.has(brandData.id));
  }

  onRowSelectionChange(selectedIds: string[]) {
    this.selectedBrandKeyList = selectedIds;
  }

  updateCheckedSet(id: number, checked: boolean): void {
    if (checked) {
      this.setOfCheckedId.add(id);
    } else {
      this.setOfCheckedId.delete(id);
    }
  }

  onItemChecked(id: number, checked: boolean): void {
    this.updateCheckedSet(id, checked);
    this.refreshCheckedStatus();

    this.reviewData = this.listOfCurrentPageData.filter((content: any) =>
      this.setOfCheckedId.has(content.id)
    );
    //check if item.renewalDate is different form other selected items
    const selectedRenewalDates = this.reviewData.map((item) => item.renewalDate);
    const allSame = selectedRenewalDates.every(
      (date) => date === selectedRenewalDates[0]
    );
    this.isDifferentRenewalMonthsForBrands = !allSame;
  }

  onAllChecked(value: boolean): void {
    //
    this.listOfCurrentPageData.forEach(
      (item) => {
        // if (
        //   !(
        //     new Date(item.renewalDate).getMonth() ===
        //       this.consolidateRenewalDate.getMonth() &&
        //     new Date(item.renewalDate).getFullYear() ===
        //       this.consolidateRenewalDate.getFullYear()
        //   )
        // ) {
        this.updateCheckedSet(item.id, value);
        // }
      }
      // this.updateCheckedSet(item.id, value)
    );
    this.refreshCheckedStatus();
  }

  refreshCheckedStatus(): void {
    this.checked = this.listOfCurrentPageData.every(({ id }) =>
      this.setOfCheckedId.has(id)
    );
    this.indeterminate =
      this.listOfCurrentPageData.some(({ id }) =>
        this.setOfCheckedId.has(id)
      ) && !this.checked;
  }

  getLocalInvestorDetails() {
    this._iS.getInvestorDetails(this.supplierId, this.isSupplierRequest).subscribe((response: any) => {
      if (response.responseStatus == ResponseStatus.success) {
        console.log(response.result.zipCode);

        this.companyDetails = {
          name: response.result.companyName || '',
          address1: response.result.streetAddress1 || '',
          address2: response.result.streetAddress2 || '',
          city: response.result.city || '',
          state: response.result.state || '',
          zip: response.result.zipCode || '',
          country: response.result.country || '',
          qboSupplierId: response.result.qboEntityId || '',
          retailPrograms: response.result.retailPrograms || {
            _id: '',
            name: '',
            code: '',
            isActive: '',
            retailSupplierId: '',
          },
        };
        this.currentInvestorData = response.result;
        this.formattedAddress = this.getFormattedAddress();
        response.result.retailPrograms.forEach((element) => {
          if (element.id === this.programId) {
            this.operatorSiteId = element.operatorSiteId || null;
          }
        });
        this.getSupplierReps();
      } else {
        this._cpS.isInvestmentHisoryLoading = false;
      }
    });
  }

  getSupplierDetails() {
    this._iS.getInvestor(this.supplierId).subscribe(
      (res: any) => {
        if (res.responseStatus == ResponseStatus.success) {
          if (res.result) {
            this.companyDetails = {
              name: res.result.companyName || '',
              address1: res.result.streetAddress1 || '',
              address2: res.result.streetAddress2 || '',
              city: res.result.city || '',
              state: res.result.state || '',
              zip: res.result.zipCode || '',
              country: res.result.country || '',
              qboSupplierId: res.result.qboEntityId || '',
              retailPrograms: res.result.retailPrograms || {
                _id: '',
                name: '',
                code: '',
                isActive: '',
                retailSupplierId: '',
              },
            };
            this.currentInvestorData = res.result;
            this.formattedAddress = this.getFormattedAddress();
            res.result.retailPrograms.forEach((element) => {
              if (element.id === this.programId) {
                this.operatorSiteId = element.operatorSiteId || null;
              }
            });
            this.getInvestorTerms();
            this.getSupplierReps();
          } else {
            this.getLocalInvestorDetails();
          }
        }
      },
      (error) => {
        console.error('API Error:', error);
      }
    );
  }

  getSupplierReps() {
    this._cpS
      .getSupplierInvestors(this.companyDetails.qboSupplierId, this.programId)
      .subscribe((res: any) => {
        if (res.responseStatus === ResponseStatus.success) {
          this.listOfReps = res.result || [];
        }
      });
  }
  getFormattedAddress() {
    if (
      !this.companyDetails.city &&
      !this.companyDetails.state &&
      !this.companyDetails.zip
    ) {
      return '';
    }
    return [
      this.companyDetails.city,
      this.companyDetails.state,
      this.companyDetails.zip,
    ].join(', ');
  }

  openNewRepModal() {
    this.showInvestorModal = true;
  }
  handleCancelInvestor() {
    this.showInvestorModal = false;
  }

  renewInvestment() {
    if (this._fS.retailProgramInvestmentForm.valid) {
      if (!this._fS.retailProgramInvestmentForm.get('isAgreed')?.value) {
        this._cS.displayMessage(
          'warning',
          'Please check terms and conditions to proceed'
        );
      } else {
        this.investmentLoading = true;

        if (this.currentInvestorData.isInvoice) {
          this.estArrivalDate.setDate(
            this.estArrivalDate.getDate() + this.netTerms
          );
        } else {
          this.estArrivalDate.setDate(
            this.estArrivalDate.getDate() + this.netTerms + 14
          );
        }

        const formvalue = this._fS.retailProgramInvestmentForm.value;

        let matchedRetailProgramSupplierId = '';
        const matchedProgram = this.companyDetails.retailPrograms.find(
          (element: any) => element.id === this.programId
        );
        const matchedRep = this.listOfReps.find(
          (element: any) => element.id === formvalue.rep
        );
        if (matchedProgram) {
          matchedRetailProgramSupplierId = matchedProgram.retailSupplierId;
        }
        const brandWithProductsForInvestment = this.reviewData.map(
          (brand: any) => {
            return {
              id: brand.id,
              name: brand.name,
              amount: brand.proratedPrice,
              renewalDate: this.consolidateRenewalDate,
              previousRenewalDate: brand.renewalDate,
            };
          }
        );
        const investmentData: RetailProgramInvestment = {
          id: '',
          supplierId: this.supplierId,
          invester: {
            id: matchedRep.id,
            name: matchedRep.name,
          },
          program: {
            id: '',
            name: '',
          },
          amount: this.amountToPay,
          description: formvalue.detailedDescription,
          brands: brandWithProductsForInvestment,
          accountingNotes: formvalue.accountingNotes,
          retailProgramId: this.programId,
          retailSupplierId: matchedRetailProgramSupplierId,
          siteId: this.operatorSiteId,
          isRenewal: true,
          estimatedArrivalDate: this.estArrivalDate,
        };

        this.renewInvestmentApiCall(investmentData);
      }
    } else {
      this._cS.markFormGroupTouched(this._fS.retailProgramInvestmentForm);
    }
  }

  renewInvestmentApiCall(investmentData: RetailProgramInvestment) {
    this._cpS
      .renewRetailProgramInvestment(investmentData)
      .subscribe((response: any) => {
        if (response.responseStatus == ResponseStatus.success) {
          this.handleCancel(response.result);
          this._cpS.displayMessage(
            responseMessageStatus.success,
            response.message
          );
        } else {
          this._cpS.displayMessage(
            responseMessageStatus.error,
            response.message
          );
        }
        this.investmentLoading = false;
      });
  }
}
